import React from 'react';

import { faExclamationCircle, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'components/ui/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import LoadingSpinner from 'components/ui/loading_spinner';
import Task from '../task';
import { useTasks } from '../context/tasks_context';

interface Props {
  taskClassName?: string;
}

export function TasksList({ taskClassName }: Props) {
  const {
    addTaskAttachment,
    currentParent,
    features,
    hideAfterReparenting,
    loading,
    paths,
    removeTaskAttachment,
    removeTaskFromList,
    replaceTask,
    selectedTask,
    showModal,
    showParents,
    showTaskModal,
    taskMenuOptions,
    tasks,
    updateTask,
  } = useTasks();

  if (loading) {
    return <LoadingSpinner />;
  } else if (tasks.length === 0) {
    return <TasksEmptyState />;
  } else {
    return <>
      {tasks.map(task => (
        <Task
          active={task.id === selectedTask?.id && showModal}
          addTaskAttachment={addTaskAttachment}
          attachmentsPath={paths.attachments}
          className={taskClassName}
          currentParent={currentParent}
          deleteTaskAttachment={removeTaskAttachment}
          features={features}
          key={task.id}
          menuOptions={taskMenuOptions}
          modalOpen={showModal}
          showParents={showParents}
          task={task}
          onClick={showTaskModal}
          onReparent={hideAfterReparenting ? removeTaskFromList : replaceTask}
          onUpdate={updateTask}
        />
      ))}
    </>;
  }
}

export function TasksEmptyState() {
  const { paths, showTaskModal } = useTasks();
  const onClick = paths.create ? () => showTaskModal() : undefined;

  return (
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faExclamationCircle} />
      </Empty.Media>
      <Empty.Title>No tasks to display</Empty.Title>
      <Empty.Content>
        {paths.create
          ? 'Create your first task to get started'
          : 'Tasks created via Contacts, Deals or Listings will populate here'}
      </Empty.Content>
      {onClick && (
        <Empty.Actions>
          <Button icon={faPlus} label="New Task" onClick={onClick} />
        </Empty.Actions>
      )}
    </Empty>
  );
}
